export default __webpack_public_path__ + "static/media/stripe-left.9b2fc759.png";